import { h } from '@stencil/core';
import { pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
export class RelatedProductsGroupCard {
  constructor() {
    this.name = undefined;
    this.imageUrl = undefined;
    this.productsCount = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("button", { class: "related-products-group-card" }, h("img", { src: this.imageUrl, alt: this.name, class: "related-products-group-card__image", loading: "lazy" }), h("h2", { class: "related-products-group-card__name" }, this.name, "\u00A0", h("span", { class: "related-products-group-card__title-count" }, "(", this.productsCount, ")")), h("se-icon", { class: "related-products-group-card__icon related-products-group-card__icon--desktop", size: pesIconSizes.NANO }, "action_layer_backward"), h("se-icon", { class: "related-products-group-card__icon related-products-group-card__icon--mobile", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left")));
  }
  static get is() { return "pes-related-products-group-card"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["group-card.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["group-card.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The name of the group"
        },
        "attribute": "name",
        "reflect": false
      },
      "imageUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The URL of the the group preview image"
        },
        "attribute": "image-url",
        "reflect": false
      },
      "productsCount": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The number of products of the group"
        },
        "attribute": "products-count",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
